// extracted by mini-css-extract-plugin
export default {"channelColumn":"Dg_ExcFl97OZMtQt9LXh","horizontal":"LB0hftuU_wtco_8RzfPD"};